import { render, staticRenderFns } from "./Confirmations.vue?vue&type=template&id=3a585fc8&"
import script from "./Confirmations.vue?vue&type=script&lang=js&"
export * from "./Confirmations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports